import type { RouterClient } from '@orpc/server';
import type { AppRouter } from '@server/rpc';

type SiblingStatus = Awaited<ReturnType<RouterClient<AppRouter>['siblingWorkspace']['status']>>;

/** A grant set of a sibling workspace (ACT2-1124 LLD §5.5), as the server names it. */
export type RudderstackGrantSetId = NonNullable<SiblingStatus['viewerGrantSets']>[number];

/** The grant sets in screen order, with the names of LLD §5.5. The server's 403 text uses the same names. */
export const RUDDERSTACK_GRANT_SETS: { id: RudderstackGrantSetId; label: string; description?: string }[] = [
  { id: 'audiences_create_delete', label: 'Create and delete audiences' },
  { id: 'audiences_edit', label: 'Edit audiences' },
  { id: 'activations', label: 'Create, delete and edit activations' },
  {
    id: 'retl_data_access',
    label: 'rETL Data Access',
    description:
      'See the records an activation failed to send, with their values, when asking why a sync failed. It is a RudderStack PII permission on every rETL source of this workspace, so it applies also in RudderStack, not only in this chat.',
  },
];

/** Why a person without `set` cannot make the write: the same advice as the server's 403 text. */
export function missingGrantReason(set: RudderstackGrantSetId): string {
  const label = RUDDERSTACK_GRANT_SETS.find((entry) => entry.id === set)?.label ?? set;
  return `Ask a RudderStack admin of your organization to give you "${label}" in this workspace.`;
}
